import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './index.css';

import { AuthProvider }   from './contexts/AuthContext';
import { GlobalProvider } from './contexts/GlobalContext';
import { ProtectedRoute, PublicOnlyRoute } from './ProtectedRoute';

// Auth pages
import Login          from './pages/Auth/Login';
import ForgetPassword from './pages/Auth/ForgetPassword';
import ResetPassword  from './pages/Auth/ResetPassword';

// Protected pages
import Dashboard    from './pages/Dashboard';
import Support      from './pages/Support';
import CompaniesList from './pages/Companies/List';
import CompanyProfile from './pages/Companies/Profile';
import AwaitingActivation from './pages/AwaitingActivation';
import DevicesList   from './pages/Devices/List';
import DeviceDetail  from './pages/Devices/Detail';
import PackagesList  from './pages/Packages/List';
import Reports       from './pages/Reports';
import AuditLogs     from './pages/Logs';
import Health        from './pages/Health';
import DeviceHealth  from './pages/DeviceHealth';
import Users         from './pages/Users';
import Account       from './pages/Account';
import Settings      from './pages/Settings';

function NotFound() {
  return (
    <div className="min-h-screen bg-bg-primary flex flex-col items-center justify-center gap-4">
      <p className="text-7xl font-black text-gradient">404</p>
      <p className="text-text-muted">Page not found</p>
      <a href="/dashboard" className="btn-primary">Go to Dashboard</a>
    </div>
  );
}

function App() {
  return (
    <GlobalProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public-only (redirect to /dashboard if already logged in) */}
            <Route element={<PublicOnlyRoute />}>
              <Route path="/"                        element={<Login />} />
              <Route path="/forget-password"         element={<ForgetPassword />} />
              <Route path="/reset/password/:token"   element={<ResetPassword />} />
            </Route>

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard"             element={<Dashboard />} />
              <Route path="/support"               element={<Support />} />
              <Route path="/awaiting-activation"   element={<AwaitingActivation />} />
              <Route path="/companies"             element={<CompaniesList />} />
              <Route path="/companies/:id"         element={<CompanyProfile />} />
              <Route path="/devices"               element={<DevicesList />} />
              <Route path="/devices/:id"           element={<DeviceDetail />} />
              <Route path="/packages"              element={<PackagesList />} />
              <Route path="/reports"               element={<Reports />} />
              <Route path="/logs"                  element={<AuditLogs />} />
              <Route path="/device-health"         element={<DeviceHealth />} />
              <Route path="/health"                element={<Health />} />
              <Route path="/users"                 element={<Users />} />
              <Route path="/profile"               element={<Account />} />
              <Route path="/settings"              element={<Settings />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GlobalProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
